(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[492],{

/***/ 68219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ER": function() { return /* binding */ Summary; },
/* harmony export */   "H1": function() { return /* binding */ H1; },
/* harmony export */   "H2": function() { return /* binding */ H2; },
/* harmony export */   "H3": function() { return /* binding */ H3; },
/* harmony export */   "H4": function() { return /* binding */ H4; },
/* harmony export */   "HU": function() { return /* binding */ FooterText; },
/* harmony export */   "O": function() { return /* binding */ CardParagraph; },
/* harmony export */   "nv": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* unused harmony export FooterLink */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71383);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42997);


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;


var H1 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h1 */ .ZP.h1(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  margin-bottom: 1.5rem;\n  text-align: ", ";\n  font-size: ", ";\n  @media screen and (max-width: ", ") {\n    font-size: ", ";\n  }\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.headingFontFamily;
}, function (_ref2) {
  var $textAlign = _ref2.$textAlign;
  return $textAlign ? $textAlign : 'initial';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.desktopFontSize.title;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.mobileFontSize.title;
}, function (_ref6) {
  var theme = _ref6.theme,
      $brand = _ref6.$brand;
  return $brand ? theme.colors.primary : theme.colors.text;
});
var H2 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h2 */ .ZP.h2(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  margin-bottom: ", ";\n  font-size: ", ";\n  position: ", ";\n  left: ", ";\n  color: ", ";\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.headingFontFamily;
}, function (_ref8) {
  var $marginBottom = _ref8.$marginBottom;
  return $marginBottom || '1.5rem';
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.typography.fontSizes[2];
}, function (_ref10) {
  var $sticky = _ref10.$sticky;
  return $sticky ? 'sticky' : 'initial';
}, function (_ref11) {
  var $sticky = _ref11.$sticky;
  return $sticky ? 0 : 'initial';
}, function (_ref12) {
  var theme = _ref12.theme,
      $brand = _ref12.$brand;
  return $brand ? theme.colors.primary : theme.colors.text;
});
var H3 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h3 */ .ZP.h3(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  margin-bottom: initial;\n  color: ", ";\n  font-size: ", ";\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.typography.headingFontFamily;
}, function (_ref14) {
  var $color = _ref14.$color;
  return $color ? $color : 'inherit';
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.typography.fontSizes[4];
});
var H4 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h4 */ .ZP.h4(_templateObject4 || (_templateObject4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: ", ";\n  margin: initial;\n  margin-bottom: initial;\n  color: ", ";\n  font-size: ", ";\n\n  display: ", ";\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: ", ";\n  overflow: ", ";\n  text-overflow: ", ";\n  min-height: ", ";\n"])), function (_ref16) {
  var theme = _ref16.theme;
  return theme.typography.headingFontFamily;
}, function (_ref17) {
  var $padding = _ref17.$padding;
  return $padding ? $padding : 'initial';
}, function (_ref18) {
  var theme = _ref18.theme,
      $brand = _ref18.$brand;
  return $brand ? theme.colors.primary : theme.colors.text;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.typography.fontSizes[5];
}, function (_ref20) {
  var $ellipsis = _ref20.$ellipsis;
  return $ellipsis && '-webkit-box';
}, function (_ref21) {
  var $ellipsis = _ref21.$ellipsis;
  return $ellipsis && 2;
}, function (_ref22) {
  var $ellipsis = _ref22.$ellipsis;
  return $ellipsis && 'vertical';
}, function (_ref23) {
  var $ellipsis = _ref23.$ellipsis;
  return $ellipsis && 'hidden';
}, function (_ref24) {
  var $ellipsis = _ref24.$ellipsis;
  return $ellipsis && 'ellipsis';
}, function (_ref25) {
  var $ellipsis = _ref25.$ellipsis;
  return $ellipsis && '3.4rem';
});
var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p */ .ZP.p(_templateObject5 || (_templateObject5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  text-align: ", ";\n  padding: ", ";\n  margin: initial;\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: calc(\n    ", " * 2\n  );\n  color: ", ";\n\n  display: ", ";\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: ", ";\n  overflow: ", ";\n  text-overflow: ", ";\n  min-height: ", ";\n"])), function (_ref26) {
  var theme = _ref26.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref27) {
  var $textAlign = _ref27.$textAlign;
  return $textAlign ? $textAlign : 'left';
}, function (_ref28) {
  var $padding = _ref28.$padding;
  return $padding ? $padding : '2rem 0';
}, function (_ref29) {
  var $fontWeight = _ref29.$fontWeight;
  return $fontWeight ? $fontWeight : 'initial';
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.typography.fontSizes[5];
}, function (_ref31) {
  var theme = _ref31.theme,
      $lineHeight = _ref31.$lineHeight;
  return $lineHeight ? $lineHeight : theme.typography.fontSizes[5];
}, function (_ref32) {
  var theme = _ref32.theme,
      $brand = _ref32.$brand,
      $color = _ref32.$color;
  return $brand ? theme.colors.primary : theme.colors[$color || 'text'];
}, function (_ref33) {
  var $ellipsis = _ref33.$ellipsis;
  return $ellipsis && '-webkit-box';
}, function (_ref34) {
  var $ellipsis = _ref34.$ellipsis;
  return $ellipsis && 4;
}, function (_ref35) {
  var $ellipsis = _ref35.$ellipsis;
  return $ellipsis && 'vertical';
}, function (_ref36) {
  var $ellipsis = _ref36.$ellipsis;
  return $ellipsis && 'hidden';
}, function (_ref37) {
  var $ellipsis = _ref37.$ellipsis;
  return $ellipsis && 'ellipsis';
}, function (_ref38) {
  var $ellipsis = _ref38.$ellipsis;
  return $ellipsis && '9.7rem';
});
var Summary = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject6 || (_templateObject6 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  text-align: ", ";\n  max-width: 100vw;\n  overflow-wrap: break-word;\n  @media screen and (min-width: ", ") {\n    font-size: ", ";\n  }\n"])), function (_ref39) {
  var $textAlign = _ref39.$textAlign;
  return $textAlign ? $textAlign : 'center';
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.typography.fontSizes[3];
});
var CardParagraph = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p */ .ZP.p(_templateObject7 || (_templateObject7 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  font-size: ", ";\n  line-height: calc(", " * 1.25);\n  color: ", ";\n"])), function (_ref42) {
  var theme = _ref42.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.typography.fontSizes[5];
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.typography.fontSizes[5];
}, function (_ref45) {
  var $color = _ref45.$color,
      theme = _ref45.theme;
  return $color ? $color : theme.colors.text;
});
var FooterLink = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a */ .ZP.a(_templateObject8 || (_templateObject8 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (_ref46) {
  var theme = _ref46.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref47) {
  var theme = _ref47.theme,
      $brand = _ref47.$brand;
  return $brand ? theme.colors.linkColours.alt : theme.colors.text;
}, function (_ref48) {
  var theme = _ref48.theme,
      $brand = _ref48.$brand;
  return $brand ? theme.colors.linkColours.altHover : theme.colors.text;
});
var FooterText = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject9 || (_templateObject9 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  text-align: center;\n  max-width: 800px;\n  line-height: 1.2;\n  a {\n    font-family: ", ";\n    color: ", ";\n  }\n"])), function (_ref49) {
  var theme = _ref49.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref50) {
  var theme = _ref50.theme;
  return theme.colors.primary;
});

/***/ }),

/***/ 28035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var SEO = function SEO(_ref) {
  var _openGraphImage$data;

  var propTitle = _ref.title,
      metaTitle = _ref.metaTitle,
      metaDescription = _ref.metaDescription,
      twitterCard = _ref.twitterCard,
      twitterSite = _ref.twitterSite,
      twitterCreator = _ref.twitterCreator,
      openGraphImage = _ref.openGraphImage,
      noindex = _ref.noindex,
      jsonSchema = _ref.jsonSchema;
  var title = propTitle || metaTitle;
  var ogImage = openGraphImage === null || openGraphImage === void 0 ? void 0 : (_openGraphImage$data = openGraphImage.data) === null || _openGraphImage$data === void 0 ? void 0 : _openGraphImage$data.attributes;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("title", {
        children: title
      }, "title"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:title",
        content: title
      }, "og:title")]
    }), metaDescription && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        name: "description",
        content: metaDescription
      }, "description"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        name: "twitter:description",
        content: metaDescription
      }, "twitter:description")]
    }), twitterCard && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:card",
      content: twitterCard
    }, "twitter:card"), twitterSite && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:site",
      content: twitterSite
    }, "twitter:site"), twitterCreator && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:creator",
      content: twitterCreator
    }, "twitter:creator"), ogImage && (ogImage === null || ogImage === void 0 ? void 0 : ogImage.url) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image",
        content: ogImage.url
      }, "og:image"), ogImage.width && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image:width",
        content: ogImage.width
      }, "og:image:width"), ogImage.height && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image:height",
        content: ogImage.height
      }, "og:image:height"), ogImage.alternativeText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image:alt",
        content: ogImage.alternativeText
      }, "og:image:alt"), ogImage.mime && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image:type",
        content: ogImage.mime
      }, "og:image:type")]
    }), jsonSchema && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(jsonSchema)
      }
    }, "jsonSchema"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      property: "robots",
      content: noindex ? 'noindex' : 'index follow'
    }, "robots")]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SEO);

/***/ }),

/***/ 9913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ BlogPost; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(71383);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50029);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_atoms_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68219);
/* harmony import */ var atomic_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var components_seo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28035);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(18813);
/* harmony import */ var reading_time__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45843);
/* harmony import */ var reading_time__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(reading_time__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42997);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);




var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var EmailSignupComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(937), __webpack_require__.e(981), __webpack_require__.e(200), __webpack_require__.e(309), __webpack_require__.e(262), __webpack_require__.e(889), __webpack_require__.e(427), __webpack_require__.e(101)]).then(__webpack_require__.bind(__webpack_require__, 8168));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8168)];
    }
  }
});
var BlogList = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(function () {
  return __webpack_require__.e(/* import() */ 798).then(__webpack_require__.bind(__webpack_require__, 2798));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(2798)];
    }
  }
});
var DynamicZone = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(981), __webpack_require__.e(200), __webpack_require__.e(688)]).then(__webpack_require__.bind(__webpack_require__, 13688));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(13688)];
    }
  }
});
var InlineShareButtons = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()( /*#__PURE__*/(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
  return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return __webpack_require__.e(/* import() */ 21).then(__webpack_require__.bind(__webpack_require__, 44021));

        case 2:
          return _context.abrupt("return", _context.sent.InlineShareButtons);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})), {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(44021)];
    }
  }
});
var BlogContentWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu)(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(["\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 1rem;\n  padding-right: 1rem;\n"])));
var LatestBlogsWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu)(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(["\n  h2 {\n    text-align: center;\n  }\n  \n  @media screen and (max-width: 1000px) {\n    :nth-child(2) {\n      > div {\n        padding: 0 2vw;\n      }\n      > div > div {\n        width: 100%;\n        min-width: unset;\n      }\n    } \n  }\n"])));
var AuthorLink = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].a */ .ZP.a(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(["\n  font-weight: bold;\n  text-decoration: underline;\n  color: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.text;
});
var __N_SSG = true;
function BlogPost(_ref3) {
  var slug = _ref3.slug,
      seoData = _ref3.seoData,
      title = _ref3.title,
      publishedAt = _ref3.publishedAt,
      author = _ref3.author,
      blocks = _ref3.blocks,
      blogs = _ref3.blogs,
      emailSignupBox = _ref3.emailSignupBox;

  var _readingTime = reading_time__WEBPACK_IMPORTED_MODULE_8___default()(blocks.filter(function (block) {
    return block.text;
  }).map(function (block) {
    return block.text;
  }).join('\n')),
      readTimeText = _readingTime.text;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(atomic_layout__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_seo__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, _objectSpread({}, seoData)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(BlogContentWrapper, {
      itemScope: true,
      itemType: "https://schema.org/Article",
      maxWidth: "calc(100vw - 2rem)",
      maxWidthMd: "800px",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Text__WEBPACK_IMPORTED_MODULE_2__.H1, {
          $textAlign: "left",
          itemProp: "headline",
          children: title
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        style: {
          marginBottom: '5rem'
        },
        children: [author && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
          children: ["By", ' ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            href: "/author/".concat(author.slug),
            passHref: true,
            legacyBehavior: true,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(AuthorLink, {
              children: author.name
            })
          }), ' ', "on", ' ']
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
          itemProp: "datePublished",
          children: (0,date_fns_format__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(publishedAt ? Date.parse(publishedAt) : new Date(), 'MMMM do, yyyy')
        }), ' • ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
          children: readTimeText
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(atomic_layout__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(DynamicZone, {
          blocks: blocks || []
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        style: {
          marginTop: '6rem',
          maxWidth: '650px',
          marginLeft: 'auto',
          marginRight: 'auto'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(EmailSignupComponent, _objectSpread({
          isFullWidth: true
        }, emailSignupBox))
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        style: {
          borderTop: '1px solid white',
          borderBottom: '1px solid white',
          margin: '6rem 0',
          padding: '4rem 0'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(InlineShareButtons, {
          config: {
            alignment: 'justified',
            radius: 4,
            padding: 12,
            networks: ['facebook', 'twitter', 'sharethis', 'email', 'reddit'],
            color: 'social',
            enabled: true,
            labels: 'cta',
            language: 'en'
          }
        })
      })]
    }), blogs.length >= 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(LatestBlogsWrapper, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Text__WEBPACK_IMPORTED_MODULE_2__.H2, {
        children: "Latest Blogs"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(BlogList, {
        blogs: blogs
      })]
    })]
  });
}

/***/ }),

/***/ 49937:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return __webpack_require__(9913);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [813,843,774,888,179], function() { return __webpack_exec__(49937); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);